// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore } from 'firebase/firestore';
import { ref, onUnmounted } from 'vue'
import { onSnapshot, collection, query, orderBy, doc, deleteDoc, where, getDocs, getDoc, updateDoc, arrayUnion, arrayRemove } from 'firebase/firestore'

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyBuQK_5nC2hrsHhW-zpORWr9F-IMdHIfvA",
  authDomain: "argent-c92c6.firebaseapp.com",
  projectId: "argent-c92c6",
  storageBucket: "argent-c92c6.firebasestorage.app",
  messagingSenderId: "973478855740",
  appId: "1:973478855740:web:4d5052407008a3e0386f39",
  measurementId: "G-9HYJJRXLKD"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

const db = getFirestore(app)
// const ohuList = db.collection('ohu-list')
// const boxes = db.collection('bxz');
// const ohu = db.collection('ohu-list')

export const getDB = () =>{
    return db
}

export const resetDay = async() =>{
    try {
    // 1. Define references for source and target documents
    const sourceDocRef = doc(db, 'ohu-list', 'jIAzyK9CTJzAVClkkexX');
    const targetDocRef = doc(db, 'ohu-list', 'G71Jh1xirkt9bGYutjJY');

    // 2. Fetch the source document
    const sourceSnapshot = await getDoc(sourceDocRef);

    if (sourceSnapshot.exists()) {
      // 3. Extract the array field from the source document
      const data = sourceSnapshot.data();
      const itemsArray = data.barcodes; // Replace with your field name

      if (Array.isArray(itemsArray) && itemsArray.length > 0) {
        // 4. Push the array data into the target collection's document
        await updateDoc(targetDocRef, {
          past: arrayUnion({
          // Store items as an object/map rather than a nested array
          items: itemsArray
        })
        });

        console.log('Array successfully migrated!');
      } else {
        console.log('The source field is empty or not an array.');
      }
    } else {
      console.log('Source document does not exist.');
    }
  } catch (error) {
    console.error('Error migrating array:', error);
  }


  const ohuRef = doc(db, "ohu-list", "jIAzyK9CTJzAVClkkexX");

  // This leaves the array field intact but empty
  await updateDoc(ohuRef, {
    barcodes: []
  });
}

// export const getKey = async id => {
//     const key = await db.collection('shipstation').get()
//     return key.exists ? key.data() : null
// }


// export const createBox = bxz => {
//     return boxesListCollection.add(bxz)
// }
// export const getBoxesColl = () => {
//     return boxesListCollection;
// }